declare global {
  interface Window {
    cookiehub?: {
      openSettings: () => void;
    };
  }
}

const Footer = {
  el: {
    cookieButton: document.getElementById('cookie-button')
  },

  init() {
    if (!this.el.cookieButton) {
      console.warn('Cookie button not found');
      return;
    }
    this.el.cookieButton.addEventListener('click', () => {
      if(window.cookiehub) {
        window.cookiehub.openSettings();
      }
    });
  }
}

export default Footer
